(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('OruloFactory', OruloFactory);

    OruloFactory.$inject = ['$resource'];

    function OruloFactory($resource) {
        return $resource('admin/api/orulo-configuration', {}, {
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            },
            'getByHubId': {
                method: 'GET',
                url: 'admin/api/orulo-configuration/hub'
            },
            'getById': {
                method: 'GET',
                url: 'admin/api/orulo-configuration'
            },
            'reconnect': {
                method: 'PUT',
                url: 'admin/api/orulo-configuration/reconnect'
            },
            'reprocess': {
                method: 'PUT',
                url: 'admin/api/orulo-configuration/reprocess'
            }
        });
    }

})();
